import { AgreementStatus } from 'agreement/AgreementStatus';
import IAgreementInstanceData from 'agreement/types/IAgreementData';
import IAgreementObjectInstanceData from 'agreementObject/types/IAgreementObjectData';

export const getActiveAgreementObjects = (
    agreements: Record<number, IAgreementInstanceData> | null | undefined,
): Map<number, IAgreementObjectInstanceData> => {
    const activeAgreementObjects = new Map<number, IAgreementObjectInstanceData>();

    if (!agreements) return activeAgreementObjects;

    for (const agreement of Object.values(agreements)) {
        for (const object of agreement.objects) {
            if (
                AgreementStatus.isActive({ agreement, objectId: object.id }) &&
                !activeAgreementObjects.has(object.id)
            ) {
                activeAgreementObjects.set(object.id, object);
            }
        }
    }

    return activeAgreementObjects;
};

export const findActiveObjectIdByUuid = (
    agreements: Record<number, IAgreementInstanceData> | null | undefined,
    unitUuid: string,
): number | null => {
    for (const object of getActiveAgreementObjects(agreements).values()) {
        if (object.uuid === unitUuid) return object.id;
    }

    return null;
};

export const findActiveAgreementForObject = (
    agreements: Record<number, IAgreementInstanceData> | null | undefined,
    objectId: number,
): IAgreementInstanceData | undefined => {
    if (!agreements) return undefined;

    return Object.values(agreements).find(
        (agreement) =>
            agreement.objects.some((object) => object.id === objectId) &&
            AgreementStatus.isActive({ agreement, objectId }),
    );
};
